import { Component, OnInit } from '@angular/core';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { GroupsService } from '../../../service/component_dependent/groups.service';

@Component({
  selector: 'app-contacts-navigation',
  templateUrl: './contacts-navigation.component.html',
  styleUrls: ['./contacts-navigation.component.scss']
})
export class ContactsNavigationComponent implements OnInit {

  protected countContacts: number = 0;
  protected countGroups: number = 0;

  constructor(private contactService: ContactsService,
    private groupService: GroupsService) { }

  ngOnInit() {
    this.initializeComponents();
  }

  private initializeComponents() {
    this.contactService.getCount().subscribe(
      (data: any) => {
        this.countContacts = data.data.total;
      }
    );

    this.groupService.getCount().subscribe(
      (data: any) => {
        this.countGroups = data.data.total;
      }
    );
  }

}
